import crashDetectionAtom from './atom'

export default crashDetectionAtom
